import * as React from 'react';
import Chevron, { ChevronPosition } from '../Icons/Chevron/Chevron';

interface ButtonProps {
  name?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  link?: string;
  isDisabled?: boolean;
  chevron?: ChevronPosition;
  dataTest?: string;
}

const Button: React.StatelessComponent<ButtonProps> = ({
  name,
  onClick,
  link,
  isDisabled,
  chevron,
  ...rest
}: ButtonProps) => {
  const buttonMarkup = (
    <button
      className="button hide-print"
      disabled={isDisabled}
      name={name}
      onClick={onClick}
      {...rest}
    >
      {chevron === ChevronPosition.Left && <Chevron />}
      {name}
      {chevron === ChevronPosition.Right && <Chevron position={ChevronPosition.Right} />}
    </button>
  );

  return (
    <div className="button-wrapper">
      {link ? (<a href={link} target="_blank" rel="noopener noreferrer">{buttonMarkup}</a>) : buttonMarkup}
    </div>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.tsx